import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

// constants
import { ClickLink } from '../../tools/Utils';
import { YcFullProjects, YcTrustUs, YcContactUs } from '@/components';

import './projects.scss';

export const Projects = withTranslation('projects')(
  class ProjectsClass extends PureComponent {
    clickLink = ClickLink;

    render() {
      return (
        <div className="p-about-us">
          <section className="s-full-projects">
            <YcFullProjects />
          </section>
          <section className="s-trustus">
            <YcTrustUs />
          </section>
          <section className="s-contact">
            <YcContactUs />
          </section>
        </div>
      );
    }
  },
);
